import Page from '@/components/pages/author/AuthorPageController';
import getStaticProps from '@/components/pages/author/AuthorPageStaticProps';
import getStaticPaths from '@/components/pages/author/AuthorPageStaticPaths';

export default Page;
export { getStaticProps, getStaticPaths };
